import { forwardRef } from 'react';
import classNames from 'classnames';
import { Button as AntButton } from 'antd';

import isMapPortal from './utils/is-map-portal';

import './Button.less';

const btnClassNames = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  success: 'btn-success',
  warning: 'btn-warning',
  danger: 'btn-danger',
  bordered: 'btn-bordered',
  transparent: 'btn-transp',
  text: 'btn-transp btn-text',
  settingsDefault: 'btn-settings',
  link: 'btn-link',
  default: 'btn-default-styles',
  defaultActive: 'btn-default-active-styles',
  custom: ''
};

const DEFAULT_BUTTON_VARIANTS = ['default', 'defaultActive'];

const Button = ({ variant, children, addMargin = true, ...props }, ref) => {
  const isNotDefaultButtonVariat = !DEFAULT_BUTTON_VARIANTS.includes(variant);

  const defaultButtonVariat = isMapPortal() ? variant : '';

  const btnVariant = isNotDefaultButtonVariat
    ? variant || 'primary'
    : defaultButtonVariat;

  const basicClassName = props.className
    ? `btn ${props.className ?? ''}`
    : `btn`;

  return (
    <AntButton
      ref={ref}
      {...props}
      className={classNames(basicClassName, {
        'button-margin': addMargin,
        [btnClassNames[btnVariant]]: true
      })}
      variant={btnVariant}
    >
      {children}
    </AntButton>
  );
};

export default forwardRef(Button);
